import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const expenseCategoryService = {
  async getExpenseCategories(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/expense-category", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getExpenseCategoryById(id) {
    if (!id) throw new Error("Expense Category ID is required");

    try {
      const response = await apiClient.get(`/expense-category/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createExpenseCategory(data) {
    try {
      const response = await apiClient.post("/expense-category", data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateExpenseCategory(id, data) {
    if (!id) throw new Error("Expense Category ID is required");

    try {
      const response = await apiClient.patch(`/expense-category/${id}`, data);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteExpenseCategory(id) {
    if (!id) throw new Error("Expense Category ID is required");

    try {
      const response = await apiClient.delete(`/expense-category/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActiveExpenseCategories() {
    try {
      const response = await apiClient.get("/expense-category/active");
      const data = extractData(response?.data || {});
      return toArray(data?.data || data?.items || data);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default expenseCategoryService;
